var render = function () {
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h
  return _c(
    "div",
    { staticClass: "calendar" },
    [
      _c("calendar-filter", {
        key: _vm.key,
        staticClass: "calendar__filter",
        attrs: { initial: _vm.params, showPast: _vm.isPastEventsShown },
        on: { change: _vm.onFilterChange },
      }),
      _vm._v(" "),
      _vm.params.type === "past"
        ? _c(
            "z-caption",
            { staticClass: "calendar__count", attrs: { tag: "p", size: "xs" } },
            [_vm._v(_vm._s(_vm.text.count) + " " + _vm._s(_vm.nav.count))]
          )
        : _vm._e(),
      _vm._v(" "),
      _c(
        "div",
        { staticClass: "calendar__content" },
        [
          _vm.list && _vm.list.length
            ? _c("results", {
                attrs: { data: _vm.list, theme: _vm.params.type },
              })
            : _c("z-not-found", { attrs: { text: _vm.text.notFound } }),
          _vm._v(" "),
          _vm.loading
            ? _c(
                "div",
                { staticClass: "calendar__preloader" },
                [_c("z-preloader")],
                1
              )
            : _vm._e(),
        ],
        1
      ),
      _vm._v(" "),
      _c(
        "div",
        { staticClass: "calendar__pagination" },
        [
          _c("z-pagination", {
            attrs: {
              "show-next": "",
              "show-prev": "",
              data: _vm.paginationData,
            },
            on: { change: _vm.onPageChange },
          }),
        ],
        1
      ),
    ],
    1
  )
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }